import { DeleteStepTemplateResponseSchema } from './delete-step-template.schema';
/**
 * Delete Step Template Endpoint Contract
 * Soft-deletes a step template by ID
 */ export const deleteStepTemplateContract = {
    method: 'DELETE',
    path: '/api/v2/step-template/:id',
    description: 'Delete a step template by ID',
    responseSchema: DeleteStepTemplateResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden',
            404: 'Step template not found'
        }
    }
};

//# sourceMappingURL=delete-step-template.contract.js.map